import React, { useRef } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { CookiesKeys, URLs } from '../../Constants/Consts'
import { fetchApi } from '../../Helpers/Functions'
import { addCategories } from '../../store/Categories'
import { updateDownloadTriggered, updateHasDownloadedValue } from '../../store/Utilities'
import { RootState } from '../../store/store'
import Cookies from "js-cookie";

export default function storeCategories() {
    const [isloading, setIsloading] = React.useState(false)
    const dispatch = useDispatch()
    const SelectedUser = useSelector(
        (state: RootState) => state.SelectedUser.SelectedUser
    );
    const { downloadTriggered: { categories: triggered } } = useSelector(
        (state: RootState) => state.Utilities
    );
    const calledOnceRef = useRef(false)
    const currentToken = Cookies.get(CookiesKeys.jwt)
    React.useEffect(() => {
        (async () => {
            if (navigator.onLine && SelectedUser.jwt && currentToken && (!calledOnceRef.current || triggered)) {
                calledOnceRef.current = true
                setIsloading(true)
                const categories = await fetchApi(
                    URLs.getCategoriesUrl())
                    .then(res => res.json())
                // update store
                dispatch(addCategories(categories))
                dispatch(updateHasDownloadedValue({ key: "categories", value: true }))
                dispatch(updateDownloadTriggered({ key: "categories", value: false }))
                setIsloading(false)
            }
        })()
    }, [SelectedUser.jwt, triggered])

    return { isloading }
}
